const LearnMore = ({ text = `Sign In`, className = `` }) => (
  <HyperLink href="https://ac-frontend.herokuapp.com/" className={className}>
    {text}
  </HyperLink>
)

// const OldLearnMore = ({ text = `Learn More`, className = `` }) => (
//   <ScrollTo href="#subscribe" class={`cursor-pointer ${className}`}>
//     {text}
//   </ScrollTo>
// )

export default LearnMore

/*
 *
 * Imports
 * 
 */

import React from 'react'

import HyperLink from '../components/HyperLink'

// import ScrollTo from '../components/ScrollTo'



// WEBPACK FOOTER //
// ./src/components/LearnMore.js